import { TModeEstimate } from "../../../..";
import useApartmentBuildingAreaMinMax from "../../../../../../../api/hooks/use-apartment-building-area-limits";
import useFacilityType from "../../../../../../../api/hooks/use-facility-type";
import useTypesBuildingByComplexId from "../../../../../../../api/hooks/use-types-building-by-complex";
import { useEffect, useState } from "react";

const useTypes = (
  selectedComplexBuilding: number | null,
  selectedComplexBuildingSecondary: number | null,
  mode: TModeEstimate
) => {
  const [selectedTypesApartment, setSelectedTypesApartment] = useState<
    number | null
  >(null);
  const [isMount, setIsMount] = useState(true);

  const {
    types: typesApartment,
    isLoading: isLoadingTypes,
    error: errorTypes,
  } = useTypesBuildingByComplexId(selectedComplexBuilding, true);

  const {
    facilityTypeList: typesApartmentSecondary,
    isLoading: isLoadingTypesSecondary,
    error: errorTypesSecondary,
  } = useFacilityType(Boolean(selectedComplexBuildingSecondary), true);

  const handleChangeTypesApartment = (type: number) => {
    setSelectedTypesApartment(type);
  };

  const handleResetTypesApartment = () => {
    setSelectedTypesApartment(null);
  };

  useEffect(() => {
    if (errorTypes) {
      console.log(errorTypes);
    }
  }, [errorTypes]);

  const {
    minMaxArea,
    isLoading: isLoadingMinMaxArea,
    isValidating: isValidatingMinMaxArea,
    mutate,
  } = useApartmentBuildingAreaMinMax(
    selectedComplexBuilding,
    selectedTypesApartment
  );

  useEffect(() => {
    if (isMount) {
      setIsMount(false);
    } else {
      mutate();
    }
  }, [selectedComplexBuilding, selectedTypesApartment]);

  const isLoadingMinMax = isLoadingMinMaxArea || isValidatingMinMaxArea;

  return {
    typesApartment:
      mode === "dealService" ? typesApartmentSecondary : typesApartment,
    minMaxArea,
    selectedTypesApartment,
    isLoadingTypes,
    isLoadingMinMax,
    handleChangeTypesApartment,
    handleResetTypesApartment,
  };
};
export default useTypes;
